import React, { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';

import '../App.css';
import { useAPI } from '../api';
import PageSection from '../components/PageSection';
import RawJsonDisplay from '../components/RawJsonDisplay';
import UserProfileSegment from '../components/UserProfileSegment';
import { AuthProfile } from 'types';

const SelectWorkspace = () => {
	const api = useAPI();
	const auth = useAuth();

	const [profile, setProfile] = React.useState<AuthProfile | null>(auth?.profile ?? null);

	useEffect(() => {
		api.get<AuthProfile>('/api/auth/profile')
		.then(json => {
			if (json.user) {
				auth?.update(json);
				setProfile(json);
			}
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const tenants = profile?.tenants ?? [];

	// Auto-redirect if exactly one tenant and one workspace
	const allWorkspaces = tenants.flatMap(t => t.workspaces.map(w => ({ tenantID: t.id, workspace: w })));
	if (allWorkspaces.length === 1) {
		return <Navigate to={`/t/${allWorkspaces[0].tenantID}/w/${allWorkspaces[0].workspace.id}`} />;
	}

	return (
		<div className="centeredContainer">
			<div>
				<h3>Choose Your Workspace</h3>

				<hr />

				<p>You are logged in as <b>{auth?.user}</b></p>

				<p><UserProfileSegment /></p>

				<hr />

				<div className="spacedFormGroup">
					{tenants.map(tenant => (
						<div key={tenant.id}>
							<h4>{tenant.name}</h4>
							{tenant.workspaces && tenant.workspaces.length > 0 ? (
								tenant.workspaces.map(workspace => (
									<div key={workspace.id} style={{ marginLeft: '20px', marginTop: '10px' }}>
										<Link to={`/t/${tenant.id}/w/${workspace.id}`}>{workspace.name}</Link>
									</div>
								))
							) : (
								<div style={{ marginLeft: '20px', color: '#888' }}>No workspaces available</div>
							)}
							<hr />
						</div>
					))}
				</div>

				<PageSection title="Raw Data" level={4}>
					<RawJsonDisplay data={profile} />
				</PageSection>
			</div>
		</div>
	);
};

export default SelectWorkspace;
